(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cp-seasonal-carousel')) {
  customElements.define('cp-seasonal-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.index = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const toggle = this.querySelector('[data-toggle]');
      this.querySelector('[data-controls]').hidden = false;
      this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1, true), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1, true), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true), options));
      toggle.addEventListener('click', () => { this.paused = !this.paused; this.updateToggle(); this.schedule(); }, options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => setTimeout(() => this.schedule(), 0), options);
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
          this.dots[this.index].focus();
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.addEventListener('shopify:block:select', event => { const slide = event.target.closest('[data-slide]'); if (slide) { this.paused = true; this.show(this.slides.indexOf(slide), false); this.updateToggle(); } }, options);
      this.slides.forEach((slide, i) => { slide.inert = i !== this.index; });
      this.updateToggle(); this.schedule();
    }
    updateToggle() {
      const toggle = this.querySelector('[data-toggle]');
      toggle.setAttribute('aria-label', this.paused ? toggle.dataset.play : toggle.dataset.pause);
      toggle.querySelector('span').textContent = this.paused ? '▶' : 'Ⅱ';
    }
    show(index, announce) {
      if (this.animating) return;
      const nextIndex = (index + this.slides.length) % this.slides.length;
      if (nextIndex === this.index) { this.schedule(); return; }
      const outgoing = this.slides[this.index];
      const incoming = this.slides[nextIndex];
      const direction = index > this.index ? 1 : -1;
      this.index = nextIndex;
      incoming.hidden = false;
      this.slides.forEach((slide, i) => { slide.inert = i !== this.index; });
      if (this.reduced.matches) {
        outgoing.hidden = true;
      } else {
        this.animating = true;
        const timing = { duration: 650, easing: 'cubic-bezier(.22,.61,.36,1)' };
        const exit = outgoing.animate([{transform:'translateX(0)'},{transform:'translateX(' + (-100 * direction) + '%)'}], timing);
        const enter = incoming.animate([{transform:'translateX(' + (100 * direction) + '%)'},{transform:'translateX(0)'}], timing);
        this.animations = [exit, enter];
        Promise.all(this.animations.map(animation => animation.finished)).then(() => {
          outgoing.hidden = true;
          this.animating = false;
        }).catch(() => { this.animating = false; });
      }
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
      if (announce) this.querySelector('[data-status]').textContent = this.dots[this.index].getAttribute('aria-label');
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || document.hidden || (this.contains(document.activeElement) && document.activeElement.matches(':focus-visible') && !document.activeElement.matches('[data-toggle]')) || this.slides.length < 2) return;
      this.timer = setTimeout(() => this.show(this.index + 1, false), Number(this.dataset.delay) || 5000);
    }
    disconnectedCallback() { this.animations?.forEach(animation => animation.cancel()); clearTimeout(this.timer); this.controller?.abort(); this.initialized = false; }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
